import { render } from "./BestInShow.vue?vue&type=template&id=81e78ebe"
import script from "./BestInShow.vue?vue&type=script&lang=ts"
export * from "./BestInShow.vue?vue&type=script&lang=ts"
script.render = render

export default script